import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarNavItem = _resolveComponent("SidebarNavItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_SidebarNavItem, {
      to: "/customers",
      icon: "team",
      title: "Manage Customers"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/organisations",
      icon: "bank",
      title: "Manage Organisations"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/users",
      icon: "user",
      title: "Manage Users"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/industries",
      icon: "database",
      title: "Manage Holders"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bank-categories",
      icon: "tags",
      title: "Bank Categories"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/product-blacklist",
      icon: "stop",
      title: "Product Blacklist"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/roadmap",
      icon: "fork",
      title: "Roadmapping"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/usage",
      icon: "stock",
      title: "Usage"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/sso",
      icon: "cluster",
      title: "Manage SSO"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/suppliers",
      icon: "shop",
      title: "Supplier Questions"
    })
  ]))
}